import { select } from "d3";

import { Action, ActionType, Ball, FrameStencil, Movement, Player } from "../../types";
import { getActionPath } from "../get-action-path";
import { getDistanceBetweenPoints } from "../get-distance-between-points";

export const DEFAULT_ACTION_DURATION = 1000;
export const DEFAULT_PASS_DURATION = 400;
export const DEFAULT_HANDOFF_DURATION = 10;
export const MS_PER_FOOT = 60;

export interface CreateMarkerMovementsProps {
  stencils: FrameStencil[];
  marker: Player | Ball;
  action: Action;
  prevMovements: Movement[];
}

export const getDurationFromAction = (action: Omit<Action, "startTime" | "endTime">): number => {
  const { actionType } = action;

  switch (actionType) {
    case ActionType.PLAYER:
    case ActionType.POSSESSION: {
      const { pos, midPoints, endPos } = action;
      if (midPoints.length === 0) {
        return getDistanceBetweenPoints({ x1: pos.x, y1: pos.y, x2: endPos.x, y2: endPos.y }) * MS_PER_FOOT;
      } else {
        const pathEl = document.createElementNS("http://www.w3.org/2000/svg", "path");
        const path = select(pathEl);
        const pathData = getActionPath({ pos, midPoints, endPos });
        path.attr("d", pathData);

        const totalLength = path.node()?.getTotalLength();
        path.remove();
        return totalLength ? totalLength * MS_PER_FOOT : DEFAULT_ACTION_DURATION;
      }
    }

    case ActionType.BALL:
      return DEFAULT_PASS_DURATION;

    case ActionType.HANDOFF:
      return DEFAULT_HANDOFF_DURATION;
  }
};
